// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxWrapper__Js8fL {
  display: flex;
  align-items: center;
  column-gap: 7px;
}

.checkboxInput__V4hIC {
  display: none;
}

.checkbox__i4FNM {
  width: 12px;
  min-width: 12px;
  height: 12px;
  position: relative;
  border: 1px solid var(--selection-controls-checkbox-surface-default);
  border-radius: 2px;
}

.checkboxLabel__bvEJK {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--selection-controls-checkbox-text);
  letter-spacing: 0;
  margin: 0;
  text-box-trim: none;
}

.isChecked__nK2_T {
  width: 6px;
  height: 6px;
  background-color: var(--selection-controls-checkbox-surface-default);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.helperText__AgotC {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__AgotC {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.required__ih_nS::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: -3px;
}

.disabled__PHUna {
  pointer-events: none;
}
.disabled__PHUna .checkbox__i4FNM {
  border-color: var(--selection-controls-checkbox-surface-disable);
  cursor: not-allowed;
}
.disabled__PHUna .checkboxLabel__bvEJK {
  color: var(--selection-controls-checkbox-text-disable);
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Checkbox/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oEAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,UAAA;EACA,WAAA;EACA,oEAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAxEF;AACF;;AA2EA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,iBAAA;AAxEF;;AA2EA;EACE,oBAAA;AAxEF;AA0EE;EACE,gEAAA;EACA,mBAAA;AAxEJ;AA2EE;EACE,sDAAA;AAzEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.checkboxWrapper {\n  display: flex;\n  align-items: center;\n  column-gap: 7px;\n}\n\n.checkboxInput {\n  display: none;\n}\n\n.checkbox {\n  width: 12px;\n  min-width: 12px;\n  height: 12px;\n  position: relative;\n  border: 1px solid var(--selection-controls-checkbox-surface-default);\n  border-radius: 2px;\n}\n\n.checkboxLabel {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--selection-controls-checkbox-text);\n  letter-spacing: 0;\n  margin: 0;\n  text-box-trim: none;\n}\n\n.isChecked {\n  width: 6px;\n  height: 6px;\n  background-color: var(--selection-controls-checkbox-surface-default);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.required::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: -3px;\n}\n\n.disabled {\n  pointer-events: none;\n\n  .checkbox {\n    border-color: var(--selection-controls-checkbox-surface-disable);\n    cursor: not-allowed;\n  }\n\n  .checkboxLabel {\n    color: var(--selection-controls-checkbox-text-disable);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxWrapper": `checkboxWrapper__Js8fL`,
	"checkboxInput": `checkboxInput__V4hIC`,
	"checkbox": `checkbox__i4FNM`,
	"checkboxLabel": `checkboxLabel__bvEJK`,
	"isChecked": `isChecked__nK2_T`,
	"helperText": `helperText__AgotC`,
	"required": `required__ih_nS`,
	"disabled": `disabled__PHUna`
};
module.exports = ___CSS_LOADER_EXPORT___;
